import React, { Component } from 'react';
import { Card, Grid, Form, Button, Table, Icon, Tag } from 'tabler-react';
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import { NotificationManager } from 'react-notifications';
import { timeToDateFill } from '../../herramientas/DateFormat';

const user = JSON.parse(sessionStorage.getItem('usuario') || '{}');

class ControladoresLocalidadesForm extends Component {
  constructor() {
    super();
    this.state = {
      usuarios: [],
      corredores: [],
      usuarioSeleccionado: null,
      corredorSeleccionado: null,
      asignaciones: [],
      loading: false,
      guardando: false,
    };
  }

  componentDidMount() {
    this.cargarCorredores();
    this.cargarUsuarios();
  }

  cargarUsuarios = () => {
    Crud_Catalogos('usuarios', '', 'get', '', [], '', '', '', [])
      .then((data) => {
        if (data) {
          const opciones = data.map((u) => ({
            value: u.id,
            label: u.persona
              ? `${u.persona.nombre || ''} ${u.persona.aPaterno || ''} ${u.persona.aMaterno || ''}`.trim() + ` (${u.username})`
              : u.username,
          }));
          this.setState({ usuarios: opciones });
        }
      })
      .catch(() => NotificationManager.error('Error al cargar usuarios', 'Error'));
  };

  buscarUsuarios = (inputValue, callback) => {
    const texto = (inputValue || '').toLowerCase();
    const filtrados = this.state.usuarios.filter((o) =>
      (o.label || '').toLowerCase().includes(texto)
    );
    callback(filtrados);
  };

  cargarCorredores = () => {
    Crud_Catalogos('corredores', '', 'get', '', [], '', '', '', [])
      .then((data) => {
        if (data) {
          const opciones = data
            .filter((c) => c.estatus === 1)
            .map((c) => ({ value: c.id, label: c.nombre }))
            .sort((a, b) => a.label.localeCompare(b.label));
          this.setState({ corredores: opciones });
        }
      })
      .catch(() => NotificationManager.error('Error al cargar corredores', 'Error'));
  };

  registrarLog = (descripcion) => {
    Crud_Catalogos('usuariosLog', '', 'post', '', {
      idBitacoraMonitoreo: 5,
      idUsuario: user.id,
      idMovimiento: 0,
      accionFecha: timeToDateFill(new Date().getTime()),
      descripcion: descripcion,
      idPlataformaTipo: 0,
    }).catch(() => {});
  };

  seleccionarUsuario = (opcion) => {
    this.setState({ usuarioSeleccionado: opcion, loading: true });
    Crud_Catalogos('controladoresLocalidades/usuario/' + opcion.value, '', 'get', '', [], '', '', '', [])
      .then((data) => {
        if (data && data.length) {
          const asignacionesConNombre = data.map((a) => {
            const corredor = this.state.corredores.find((c) => c.value === a.idCorredor);
            return { ...a, nombreCorredor: corredor ? corredor.label : 'Corredor ' + a.idCorredor };
          });
          this.setState({ asignaciones: asignacionesConNombre, loading: false });
        } else {
          this.setState({ asignaciones: [], loading: false });
        }
      })
      .catch(() => this.setState({ asignaciones: [], loading: false }));
  };

  agregar = () => {
    const { usuarioSeleccionado, corredorSeleccionado } = this.state;
    if (!usuarioSeleccionado) {
      NotificationManager.warning('Seleccione un usuario', 'Atención');
      return;
    }
    if (!corredorSeleccionado) {
      NotificationManager.warning('Seleccione un corredor', 'Atención');
      return;
    }
    if (this.state.asignaciones.find((a) => a.idCorredor === corredorSeleccionado.value)) {
      NotificationManager.warning('Este corredor ya está asignado al usuario', 'Atención');
      return;
    }
    this.setState({ guardando: true });
    const body = {
      idCorredor: corredorSeleccionado.value,
      idUsuario: usuarioSeleccionado.value,
    };
    Crud_Catalogos('controladoresLocalidades', '', 'post', '', body, '', '', '', [])
      .then((res) => {
        if (res) {
          NotificationManager.success(corredorSeleccionado.label, 'Corredor asignado');
          this.registrarLog(
            'Asignación de localidad de controlador: ' + corredorSeleccionado.label + ' al usuario: ' + usuarioSeleccionado.label
          );
          this.seleccionarUsuario(usuarioSeleccionado);
          this.setState({ corredorSeleccionado: null, guardando: false });
        }
      })
      .catch(() => {
        NotificationManager.error('Error al asignar corredor', 'Error');
        this.setState({ guardando: false });
      });
  };

  eliminar = (idCorredor, nombreCorredor) => {
    if (!window.confirm('¿Está seguro de eliminar el corredor "' + nombreCorredor + '"?')) return;
    const { usuarioSeleccionado } = this.state;
    this.setState({ guardando: true });
    Crud_Catalogos('controladoresLocalidades', '', 'delete', idCorredor + '/' + usuarioSeleccionado.value, '', '', '', '', [])
      .then((res) => {
        if (res !== false) {
          NotificationManager.info('Corredor removido', 'Eliminado');
          this.registrarLog(
            'Eliminación de localidad de controlador: ' + nombreCorredor + ' del usuario: ' + usuarioSeleccionado.label
          );
          this.seleccionarUsuario(usuarioSeleccionado);
        }
        this.setState({ guardando: false });
      })
      .catch(() => {
        NotificationManager.error('Error al eliminar', 'Error');
        this.setState({ guardando: false });
      });
  };

  render() {
    const { corredores, usuarioSeleccionado, corredorSeleccionado, asignaciones, loading, guardando } = this.state;

    return (
      <div className="row">
        <div className="col-12">
          <Card title="Asignar Corredores a Usuarios">
            <Card.Body>
              <Grid.Row>
                <Grid.Col sm={12} md={5}>
                  <Form.Group label="Buscar usuario">
                    <AsyncSelect
                      value={usuarioSeleccionado}
                      onChange={this.seleccionarUsuario}
                      loadOptions={this.buscarUsuarios}
                      defaultOptions={false}
                      placeholder="Escriba el nombre del usuario..."
                      noOptionsMessage={() => 'Escriba para buscar usuarios'}
                      loadingMessage={() => 'Buscando...'}
                      cacheOptions
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col sm={12} md={5}>
                  <Form.Group label="Corredor a asignar">
                    <Select
                      value={corredorSeleccionado}
                      onChange={(e) => this.setState({ corredorSeleccionado: e })}
                      options={corredores.filter(
                        (c) => !asignaciones.find((a) => a.idCorredor === c.value)
                      )}
                      placeholder="Seleccione un corredor..."
                      isDisabled={!usuarioSeleccionado}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col sm={12} md={2} style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '15px' }}>
                  <Button
                    color="primary"
                    block
                    onClick={this.agregar}
                    disabled={!usuarioSeleccionado || !corredorSeleccionado || guardando}
                    loading={guardando}
                  >
                    <Icon name="plus" className="mr-1" />
                    Asignar
                  </Button>
                </Grid.Col>
              </Grid.Row>
            </Card.Body>
          </Card>
        </div>

        <div className="col-12">
          <Card
            title={
              usuarioSeleccionado ? (
                <span>
                  Corredores asignados a: {usuarioSeleccionado.label}{' '}
                  <Tag color={asignaciones.length > 0 ? 'blue' : 'secondary'} className="ml-2">
                    {asignaciones.length}
                  </Tag>
                </span>
              ) : (
                'Seleccione un usuario para ver sus corredores'
              )
            }
          >
            <Card.Body>
              {loading ? (
                <div className="text-center p-4">Cargando...</div>
              ) : asignaciones.length > 0 ? (
                <Table cards striped responsive className="table-vcenter"
                  headerItems={[
                    { content: 'ID CORREDOR' },
                    { content: 'NOMBRE CORREDOR' },
                    { content: 'ACCIONES' },
                  ]}
                >
                  <Table.Body>
                    {asignaciones
                      .sort((a, b) => (a.nombreCorredor || '').localeCompare(b.nombreCorredor || ''))
                      .map((a) => (
                        <Table.Row key={a.idCorredor}>
                          <Table.Col>{a.idCorredor}</Table.Col>
                          <Table.Col>{a.nombreCorredor}</Table.Col>
                          <Table.Col>
                            <Button
                              color="danger"
                              size="sm"
                              outline
                              onClick={() => this.eliminar(a.idCorredor, a.nombreCorredor)}
                              disabled={guardando}
                            >
                              <Icon name="trash-2" />
                            </Button>
                          </Table.Col>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              ) : usuarioSeleccionado ? (
                <div className="text-center text-muted p-5">
                  <Icon name="inbox" style={{ fontSize: '3rem', opacity: 0.4 }} />
                  <p className="mt-3">Este usuario no tiene corredores asignados</p>
                </div>
              ) : (
                <div className="text-center text-muted p-5">
                  <Icon name="user" style={{ fontSize: '3rem', opacity: 0.4 }} />
                  <p className="mt-3">Seleccione un usuario para comenzar</p>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default ControladoresLocalidadesForm;
